import type { FormatOutput, FormatPreset } from '@pulsify/shared/dto'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { formatConverterApi } from '../api'

interface ConvertFormatVars {
  file: File
  presets: FormatPreset[]
  output: FormatOutput
  focus?: string
}

export function useConvertFormat(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ file, presets, output, focus }: ConvertFormatVars) =>
      formatConverterApi.convert(businessId, file, presets, output, focus),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.CREDITS_BALANCE, businessId),
      })
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.GENERATED_ASSETS, businessId),
      })
    },
  })
}
